export default "__VITE_ASSET__CvH$yV0z__"